export default defineNuxtPlugin(async (nuxtApp) => {
    const user = useStrapiUser()
    const strapi = useStrapi()

    const populateUser = async (u) => {
        if (u && u.accesslevel) {
            const accesslevelId = typeof u.accesslevel === 'object' ? u.accesslevel.id : u.accesslevel

            if (accesslevelId && (!u.accesslevel.route)) {
                try {
                    const { data } = await strapi.findOne('accesslevels', accesslevelId)
                    if (data && data.attributes) {
                        user.value = {
                            ...user.value,
                            accesslevel: {
                                id: accesslevelId,
                                ...data.attributes
                            }
                        }
                        console.log('User accesslevel populated successfully', user.value)
                    }
                } catch (error) {
                    console.error('Failed to populate user accesslevel:', error)
                }
            }
        }
    }

    // Handle initial load if user is already there
    if (user.value) {
        await populateUser(user.value)
    }

    // Watch for changes (login/logout)
    watch(user, (newUser) => {
        if (newUser) {
            populateUser(newUser)
        }
    })

    // Provide the populate method if needed manually
    return {
        provide: {
            populateUser: () => populateUser(user.value)
        }
    }
})
